import type { Messages } from "../catalogue.en";

export const financeSettlement: Partial<Messages> = {
  "finance.settlement.responsibilitiesTitle": "Обязательства",
  "finance.settlement.responsibilitiesTableLabel": "Позиции обязательств",
  "finance.settlement.responsibilitiesLoading": "Загружаем позиции обязательств",
  "finance.settlement.responsibilitiesFailed":
    "Не удалось загрузить позиции обязательств.",
  "finance.settlement.responsibilitiesEmpty": "Позиций обязательств нет",
  "finance.settlement.responsibilitiesEmptyDetail":
    "Утверждённые обязательства, на которые можно распределить деньги, появятся здесь.",
  "finance.settlement.columnServiceDate": "Дата услуги",
  "finance.settlement.columnBeneficiary": "Получатель услуги",
  "finance.settlement.columnDueDate": "Срок оплаты",
  "finance.settlement.columnOutstanding": "К оплате",
  "finance.settlement.columnAllocatable": "Доступно к распределению",
  "finance.settlement.columnSettled": "Погашено",
  "finance.settlement.dueStatus.unresolved": "Срок не задан",
  "finance.settlement.dueStatus.not_due": "Не наступил",
  "finance.settlement.dueStatus.due": "Сегодня",
  "finance.settlement.dueStatus.overdue": "Просрочено",
  "finance.settlement.dueStatus.settled": "Погашено",
  "finance.settlement.allocationsTitle": "Распределения",
  "finance.settlement.allocationsTableLabel": "Распределения",
  "finance.settlement.allocationsLoading": "Загружаем распределения",
  "finance.settlement.allocationsFailed": "Не удалось загрузить распределения.",
  "finance.settlement.allocationsEmpty": "Распределений пока нет",
  "finance.settlement.allocationsEmptyDetail":
    "Деньги, привязанные к позициям обязательств, появятся здесь.",
  "finance.settlement.columnPostingDate": "Дата проводки",
  "finance.settlement.columnKind": "Вид",
  "finance.settlement.columnAmount": "Сумма",
  "finance.settlement.columnReversible": "Можно снять",
  "finance.settlement.columnRecorded": "Записано",
  "finance.settlement.kindAllocation": "Распределение",
  "finance.settlement.kindReversal": "Снятие",
  "finance.settlement.digestTitle": "Распределение",
  "finance.settlement.allocate": "Распределить деньги",
  "finance.settlement.reverse": "Снять",
  "finance.settlement.reallocate": "Перераспределить",
  "finance.settlement.allocateTitle": "Распределение денег",
  "finance.settlement.allocateDetail":
    "Привязка свободных денег поступления к одной утверждённой позиции обязательства.",
  "finance.settlement.allocateSubmit": "Распределить",
  "finance.settlement.allocateSubmitting": "Распределяем",
  "finance.settlement.allocateUnsaved": "Неотправленное распределение",
  "finance.settlement.reverseTitle": "Снятие денег",
  "finance.settlement.reverseDetail":
    "Возврат части этого распределения обратно в исходное поступление.",
  "finance.settlement.reverseSubmit": "Снять",
  "finance.settlement.reverseSubmitting": "Снимаем",
  "finance.settlement.reverseUnsaved": "Неотправленное снятие",
  "finance.settlement.reallocateTitle": "Перераспределение денег",
  "finance.settlement.reallocateDetail":
    "Снятие части этого распределения и привязка её к другой позиции одной командой.",
  "finance.settlement.reallocateSubmit": "Перераспределить",
  "finance.settlement.reallocateSubmitting": "Перераспределяем",
  "finance.settlement.reallocateUnsaved": "Неотправленное перераспределение",
  "finance.settlement.unsavedDetail": "Введённые данные будут потеряны.",
  "finance.settlement.receiptField": "Исходное поступление",
  "finance.settlement.receiptRequired":
    "Выберите поступление, из которого идут деньги.",
  "finance.settlement.receiptOption": "{date} — свободно {amount}",
  "finance.settlement.targetOwnerField": "Владелец цели",
  "finance.settlement.targetOwnerPlaceholder": "Поиск людей и юридических лиц",
  "finance.settlement.targetAccountNone":
    "У этого владельца нет действующего расчётного счёта.",
  "finance.settlement.targetFailed": "Не удалось прочитать целевой счёт.",
  "finance.settlement.portionField": "Позиция обязательства",
  "finance.settlement.portionRequired":
    "Выберите позицию, к которой привязываются деньги.",
  "finance.settlement.portionOption": "{date} — доступно {amount}",
  "finance.settlement.amountField": "Сумма",
  "finance.settlement.amountRequired": "Введите сумму перевода.",
  "finance.settlement.amountExceeds":
    "Сумма больше, чем позволяют источник или позиция.",
  "finance.settlement.instructionField": "Ссылка на распоряжение",
  "finance.settlement.instructionRequired":
    "Укажите распоряжение, по которому идёт операция, — документ, сообщение или квитанцию.",
  "finance.settlement.crossOwnerConfirm":
    "Владелец счёта распорядился об этой операции на счёт другой стороны.",
  "finance.settlement.crossOwnerRequired": "Подтвердите распоряжение владельца.",
  "finance.settlement.reasonField": "Причина",
  "finance.settlement.reasonRequired": "Укажите причину.",
  "finance.settlement.accountsLoading": "Читаем счета",
  "finance.settlement.accountsFailed": "Не удалось прочитать счета.",
  "finance.settlement.reload": "Перечитать счета",
  "finance.settlement.reloadFailed": "Не удалось перечитать счета.",
  "finance.settlement.reloaded":
    "Счета перечитаны. Проверьте черновик и отправьте.",
  "finance.settlement.failed": "Не удалось выполнить расчётную операцию.",
  "finance.settlement.conflict":
    "Счёт изменился, пока вы работали. Перечитайте счета и повторите.",
  "finance.settlement.accountStateConflict":
    "Состояние счёта не позволяет эту операцию.",
  "finance.settlement.eligibilityConflict":
    "Право по позиции изменилось. Перечитайте счета и проверьте позицию.",
  "finance.settlement.responsibilityExceeded":
    "Сумма больше, чем эта позиция ещё допускает.",
  "finance.settlement.fundsInsufficient":
    "В поступлении уже нет такой свободной суммы.",
  "finance.settlement.fundsRestricted":
    "Деньги этого поступления закреплены за одним пациентом и не могут оплатить эту позицию.",
  "finance.settlement.reversalExceeded":
    "Сумма больше, чем это распределение ещё может вернуть.",
  "finance.settlement.delegationUnavailable":
    "Полномочие, на которое опирается операция, недоступно.",
  "finance.settlement.periodClosed":
    "Финансовый период этой даты закрыт. Сначала откройте его в управлении финансами.",
  "finance.settlement.amountInvalid":
    "Не удалось прочитать сумму. Введите её в числовом формате клиники.",
  "finance.settlement.amountOverflow": "Сумма слишком велика.",
  "finance.settlement.currencyMismatch": "Валюта суммы не совпадает с валютой счёта.",
  "finance.settlement.attemptConflict":
    "Эта попытка уже отправлена с другими данными. Закройте форму и начните заново.",
  "finance.settlement.forbidden":
    "У вас нет права перемещать удерживаемые деньги.",
  "finance.settlement.invalid": "Проверьте введённые данные.",

  "finance.refunds.title": "Возвраты",
  "finance.refunds.tableLabel": "Возвраты",
  "finance.refunds.loading": "Загружаем возвраты",
  "finance.refunds.loadFailed": "Не удалось загрузить возвраты.",
  "finance.refunds.empty": "Возвратов не записано",
  "finance.refunds.emptyDetail":
    "Фактические выплаты с этого счёта появятся здесь.",
  "finance.refunds.columnCashDate": "Кассовая дата",
  "finance.refunds.columnRecipient": "Получатель",
  "finance.refunds.columnMethod": "Способ",
  "finance.refunds.columnAmount": "Сумма",
  "finance.refunds.columnRecorded": "Записано",
  "finance.refunds.recordAction": "Записать возврат",
  "finance.refunds.recordTitle": "Запись возврата",
  "finance.refunds.recordDetail":
    "Свидетельство фактической выплаты обратно исходному плательщику поступления.",
  "finance.refunds.recordSubmit": "Записать возврат",
  "finance.refunds.recordSubmitting": "Записываем",
  "finance.refunds.previewLoading": "Читаем лимит возврата",
  "finance.refunds.previewFailed": "Не удалось прочитать лимит возврата.",
  "finance.refunds.originalPayer": "Исходный плательщик",
  "finance.refunds.originalMethod": "Исходный способ",
  "finance.refunds.originalCashDate": "Исходная кассовая дата",
  "finance.refunds.maximum": "Доступно к возврату",
  "finance.refunds.amountField": "Сумма",
  "finance.refunds.amountRequired": "Введите выплаченную сумму.",
  "finance.refunds.amountExceedsMax":
    "Сумма больше, чем это поступление может вернуть.",
  "finance.refunds.methodField": "Способ",
  "finance.refunds.methodChangeReasonField": "Причина смены способа",
  "finance.refunds.methodChangeReasonRequired":
    "Укажите, почему способ выплаты отличается от исходного.",
  "finance.refunds.cashDateField": "Кассовая дата",
  "finance.refunds.evidenceField": "Ссылка на свидетельство",
  "finance.refunds.evidenceRequired":
    "Укажите свидетельство выплаты — квитанцию, перевод или кассовый документ.",
  "finance.refunds.reasonField": "Причина",
  "finance.refunds.reasonRequired": "Укажите причину.",
  "finance.refunds.unsavedIntent": "Незаписанный возврат",
  "finance.refunds.unsavedDetail": "Введённый возврат будет потерян.",
  "finance.refunds.reload": "Перечитать поступление",
  "finance.refunds.reloadFailed": "Не удалось перечитать поступление.",
  "finance.refunds.reloaded":
    "Поступление перечитано. Проверьте черновик и отправьте.",
  "finance.refunds.failed": "Не удалось записать возврат.",
  "finance.refunds.conflict":
    "Счёт изменился, пока вы работали. Перечитайте поступление и повторите.",
  "finance.refunds.exceedsAvailable":
    "В поступлении уже нет такой суммы к возврату. Перечитайте поступление.",
  "finance.refunds.evidenceAlreadyRecorded":
    "Возврат с этим свидетельством уже записан по этому поступлению.",
  "finance.refunds.periodClosed":
    "Финансовый период этой кассовой даты закрыт. Откройте его в управлении финансами или выберите другую дату.",
  "finance.refunds.amountInvalid":
    "Не удалось прочитать сумму. Введите её в числовом формате клиники.",
  "finance.refunds.amountOverflow": "Сумма слишком велика.",
  "finance.refunds.currencyMismatch": "Валюта суммы не совпадает с валютой счёта.",
  "finance.refunds.attemptConflict":
    "Эта попытка уже отправлена с другими данными. Закройте форму и начните заново.",
  "finance.refunds.forbidden": "У вас нет права записывать возвраты.",
  "finance.refunds.invalid": "Проверьте данные возврата.",
};
